export default function <T = number>(pageSize: T) {
    if (typeof pageSize !== 'number') return pageSize
    if (!pageSize) return pageSize as T
    if (isNaN(pageSize)) return Number.MAX_SAFE_INTEGER
    if (pageSize < 0) return Number.MAX_SAFE_INTEGER
    if (pageSize > Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER
    return pageSize as T
}
